import type { BaseController } from '@infra/controllers/base.controller';
import type { RecordCallUuidUsecase } from '@usecases/record-call-uuid.usecase';

export type RecordCallUuidInput = {
  phoneNumber: string;
  callUuid: string;
};

export type RecordCallUuidOutput = void;

export class RecordCallUuidController
  implements BaseController<RecordCallUuidInput, RecordCallUuidOutput>
{
  constructor(private usecase: RecordCallUuidUsecase) {}

  async handle(request: RecordCallUuidInput): Promise<RecordCallUuidOutput> {
    await this.usecase.run(request);
  }
}
